import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import './CRLogoAnimation.css';

const CRLogoAnimation = props => {

  const { show, transitionOut, duration, iterations, delay, openInstr } = props,
    [frameClassName, setFrameClassName] = useState(' simple-show-hide-animation'),
    frameStyle = {animationDuration: duration || '1s', animationIterationCount: iterations || 'infinite', delay: delay || 0} ;

  const handleAnimationEnd = evt=>{
    const { animationName } = evt;

    if (animationName === 'simple-show-hide') {
      if (transitionOut) {
        transitionOut();
      }

      setFrameClassName('');
    } 
  }
  
  useEffect(()=>{

    if (show) {
      setFrameClassName(' simple-show-hide-animation')
    }
  }, [show]);

  return (
    <div className={'logo-animation'}  onAnimationEnd={handleAnimationEnd} onClick={openInstr}>
      <div className={'frame frame2' + frameClassName} style={frameStyle}/>
      {/* <div className={'frame frame2'} /> */}
    </div>
  );
};

CRLogoAnimation.propTypes = {
  transitionOut: PropTypes.func.isRequired,
  delay: PropTypes.number
};

export default CRLogoAnimation;



// WEBPACK FOOTER //
// ./src/components/CRLogoAnimation.jsx